<template>
  <create-saved-grocery-from-instacart-cart />
</template>

<script setup lang="ts">
import CreateSavedGroceryFromInstacartCart from '@/components/Main/Operator/Grocery/CreateSavedGroceryFromInstacartCart.vue';
</script>

<style scoped lang="scss"></style>
